<template>
    <v-simple-table>
        <tbody>
            <tr>
                <td><strong>{{ $t('deposito.labels.nombre') }}</strong></td>
                <td>{{ item.nombre }}</td>
            </tr>
            <tr v-if="item.direccion">
                <td><strong>{{ $t('deposito.labels.direccion') }}</strong></td>
                <td>{{ item.direccion }}</td>
            </tr>
            <tr v-if="item.descripcion">
                <td><strong>{{ $t('deposito.labels.descripcion') }}</strong></td>
                <td>{{ item.descripcion }}</td>
            </tr>
        </tbody>
    </v-simple-table>
</template>

<script>
    export default {
        name: "DepositoShowData",
        props: {
            item: {type: Object, required: true}
        }
    }
</script>

<style scoped>

</style>

